import { enumLockStatus } from "../constants";

export function ContentLocked(lockStatus) {
  return (
    lockStatus == enumLockStatus.contentLocked || lockStatus == enumLockStatus.contentPosLocked
  );
}
